// general purpose utils

export const EMPTY_FILTER = '-';

export const optionalUrlSegment = (segment) => segment ? `${segment}/` : '';

export const prefixIfNeeded = (url = '') => (
    url && !url.match(/https?:\/\//)
        ? `http://${url}`
        : url
);

export const stripEmptyFilters = (url = '') => `${url}`.replace(/(-\/)+-?$/, '');

export const filterSegment = (value) => (
    `${value || EMPTY_FILTER}/`
);

export const ensureProtocol = url => /^http(s?):\/\//i.test(url) ? url : `http://${url}`;

// app specific urls

export const getIndexUrl = () => '/';

const _getAuctionListFullUrl = firstSegment => (page, category, region, date) => (
    stripEmptyFilters(
        `/${firstSegment}/${page || '1'}/`
        + filterSegment(category)
        + filterSegment(region)
        + filterSegment(date)
    )
);
export const getAuctionListFullUrl = _getAuctionListFullUrl('auctions');
export const getPastAuctionListFullUrl = _getAuctionListFullUrl('past');

export const getAuctionUrl = (id = '') => `/auction/${id}`;

export const getAuctioneerListUrl = (page, expertise, search, association) => (
    stripEmptyFilters(
        `/members/${page || '1'}/`
        + filterSegment(expertise)
        + filterSegment(search)
        + filterSegment(association)
    )
);

export const getAuctioneerUrl = (id = '') => `/profile/${id}`;

export const getAuctionLightboxUrl = (auctionId = '', photoId = '') => auctionId && photoId
    ? `${getAuctionUrl(auctionId)}/photo/${photoId}`
    : '';
